module.exports = __webpack_public_path__ + "static/media/blue_bg.94aace44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blue_bg.png
// module id = 1474
// module chunks = 0